export const errorEvents = {
    errorLogin: function () { console.log("login"); },
    onErrorMicro: function () { console.log("login"); },
    errorReceivedUnavailables: function () { console.log("getUnavailables"); },
    errorReadyWithPassword: function () { console.log("setReadyWithPassword"); },
    errorReceivedDispositions: function () { console.log("getDispositions"); },
    errorReceivedDispositionsAndNumbers: function () {console.log("getDispositionsAndNumbers"); },
    errorReceivedGetPhoneNumbers: function () {console.log("getPhoneNumbers"); },
    errorReceivedUnavailablesHistory: function () {console.log("getUnavailablesHistory"); },
    errorTransfer: function () { console.log("errorTransfer"); },
    errorReceivedCamps: function () {console.log("errorReceivedCamps");},
    errorReceivedCallsHistory: function () {console.log("getCallsToday");},
    onConnectionBackgroundAttempt: function () { console.log("error-1006"); },
    onConnectionAttempt: function () { console.log("error-8001"); },
    onConnectionLost: function () { console.log("error-1"); },
    errorListAdminsToChat: function () {console.log("getAdminsToChat")},
    errorChatMessages: function () {console.log("getChats")},
    errorIVRList: function () {console.log("getIVRList")},
    warnManualCallPhoneLength: function () {console.log("warnManualCallPhoneLength")},
    errorManualCall: function () {console.log("errorManualCall")},
  };